export enum NewsFileTypeEnum {
    Image = 1,
    Document = 2
}